import * as React from 'react';
import {Paper} from "@mui/material";

import {Add, Export, Report} from "../../assets/images";
import { useLocation ,  Link} from 'react-router-dom';
interface PanelOptionProps {
    path: string;
    icon: string;
    title: string;
    subtitle: string;
}

const panelOptions: PanelOptionProps[] = [
    { path: '/agregar-vehiculo', icon: Add, title: 'Agregar', subtitle: 'Vehiculo' },
    { path: '/operacion-tour', icon: Report, title: 'Agregar', subtitle: 'Operación' },
    { path: '/exportar-reportes', icon: Export, title: 'Exportar', subtitle: 'Reportes' },
];
const PanelOption: React.FC<PanelOptionProps> = ({ path, icon, title, subtitle }) => {
    const location = useLocation();
    const isActive = location.pathname === path;
    const bgColor = isActive ? 'bg-green' : 'bg-gray';

    return (
        <Link to={path} className={"link-panel"}>
        <Paper elevation={3} className={`${bgColor} pd-25 btn-panel`}>
            <div className="cont-txt-btn-panel">
                <img src={icon} alt="" />
                <div>
                    <p className="txt-btn-panel-1">{title}</p>
                    <p className="txt-btn-panel-2">{subtitle}</p>
                </div>
            </div>
        </Paper>
        </Link>
    );
};
function SideBar() {
    return (
        <>
                    <div>
                        <div className="cont-btn-Panel">
                            {panelOptions.map(option => (
                                <PanelOption key={option.path} {...option}  />
                            ))}
                        </div>
                    </div>
        </>
    );
}

export default SideBar;
